import { CommonContainer } from 'components';

const NotFound = (): JSX.Element => {
  return <CommonContainer>Page Not Found</CommonContainer>;
};

export default NotFound;
